import { createAsyncThunk } from '@reduxjs/toolkit';

import { authApi } from './authApi';

export const fetchContractById = createAsyncThunk(
  'contracts/fetchById',
  async (id: string) => await authApi.get(`contracts/${id}/`)
);

export const fetchContractingParty = createAsyncThunk(
  'contract/contractingParties',
  async (id: string) =>
    await authApi.get(`contracts/insights/${id}/contracting_parties/`)
);
